export const authConstants = {
  AUTH_REQUEST: 'AUTH_REQUEST',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_FAILURE: 'AUTH_FAILURE',
  REG_REQUEST: 'REG_REQUEST',
  REG_SUCCESS: 'REG_SUCCESS',
  REG_FAILURE: 'REG_FAILURE',
  AUTH_UPDATED: 'AUTH_UPDATED',

  CLIENTIPS_REQUEST: 'CLIENTIPS_REQUEST',
  CLIENTIPS_SUCCESS: 'CLIENTIPS_SUCCESS',
  CLIENTIPS_FAILURE: 'CLIENTIPS_FAILURE',
}
